import React from 'react';
import ScheduleCall from '../common/schedule-call';
import ClientCarousel from '../home/client-carousel';

const TechHeroPythonDevelopment = () => {
    return (
        <section className="hero home-hero technology-herosection relative aiml-hero-section">
            <video playsInline autoPlay muted loop className="aimlvideo" height="100%" width="100%">
                <source src="media/video-hero-bg.mp4" type="video/mp4" />
            </video>
            <div className="counter-overlay"></div>
            <div className="container lg:container md:mx-auto top-hero">
                <div className="row grid lg:grid-cols-12 hero-row gap-6 relative z-[1] h-full">
                    <div className="lg:col-span-8 md:col-span-11 gap-4 grid">
                        <div className="inline-flex flex-col lg:items-start gap-5 hero-content justify-center h-full">
                            <p className="mb-0 fs-lg font-semibold text-white">Python Development Company</p>
                            <h1 className="mb-0 text-yellow">
                                Future-Proof your Business with Expert Python Development Services
                            </h1>
                            <p className="mb-0 font-semibold text-white">
                                Leverage the power of Python to build powerful, high-performing websites. From web apps to
                                AI-driven solutions - partner with an industry-leading Python development company to build custom
                                applications for innovation-ready companies.
                            </p>
                            <ScheduleCall />
                        </div>
                    </div>
                </div>
            </div>
            <ClientCarousel />
        </section>
    );
};

export default TechHeroPythonDevelopment;
